import { getListAvatarDecor } from "@/services/decoration";
import { useEffect, useState } from "react";

export interface AvatarDecor {
  id: number,
  name: string,
  price: number,
  decoUrl: string,
  mimeType: string,
  createdAt: string
}

const useFetch = () => {
  const pageSize = 30;
  const [loading, setLoading] = useState(false);
  const [list, setList] = useState<AvatarDecor[]>([]);

  const handleGetListDecor = async (page: number) => {
    setLoading(true);
    const res = await getListAvatarDecor({ 
      size: pageSize, 
      offset: (page - 1) * pageSize,
    });

    setList(res.data.items || [])
    setLoading(false);
  }

  useEffect(() => {
    handleGetListDecor(1);
  }, []);

  return {
    loading,
    list
  }
}

export default useFetch;